module.exports = __webpack_public_path__ + "img/red.505b8fbf.png";